import api from './apiService';

export interface PhysicalField {
  id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  slug: string;
  name: string;
  description: string;
  arena_id: number;
  capacity: number;
  size: string;
  surface_type: string;
  images: Record<string, any>;
  location_info: Record<string, any>;
  is_active: boolean;
  arena: {
    id: number;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
    slug: string;
    owner_id: number;
    staff_id: number;
    name: string;
    description: string;
    email: string;
    phone: string;
    address: string;
    kode_wilayah: string;
    currency: string;
    sport_categories: {
      categories: string[];
    };
    facilities: {
      facilities: string[];
    };
    images: {
      images: string[];
    };
    maps: {
      google_maps_url: string;
    };
    opening_hours: Record<string, string>;
    social_links: Record<string, string>;
    is_refundable: boolean;
    rules: {
      rules: string[];
    };
    is_verified: boolean;
    is_active: boolean;
    expired_at: string;
    owner: {
      id: number;
      created_at: string;
      updated_at: string;
      deleted_at: string | null;
      username: string;
      email: string;
      phone: string | null;
      role: string;
    };
  };
}

export interface PhysicalFieldsApiResponse {
  success: boolean;
  message: string;
  data: {
    pagination: {
      current_page: number;
      per_page: number;
      total: number;
      total_pages: number;
    };
    physical_fields: PhysicalField[];
  };
}

class ArenaFieldService {
  private cache = new Map<string, { data: PhysicalField[]; timestamp: number }>();
  private readonly CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  async getPhysicalFieldsForArena(arenaSlug: string): Promise<PhysicalField[]> {
    try {
      const cacheKey = `physical-fields-${arenaSlug}`;
      const cached = this.cache.get(cacheKey);

      if (cached && Date.now() - cached.timestamp < this.CACHE_DURATION) {
        return cached.data;
      }

      const response = await api.get<PhysicalFieldsApiResponse>(
        `/arenas/${arenaSlug}/physical-fields`
      );

      if (response.data.success) {
        const physicalFields = response.data.data.physical_fields;
        this.cache.set(cacheKey, { data: physicalFields, timestamp: Date.now() });
        return physicalFields;
      }

      console.error('Failed to fetch physical fields:', response.data);
      return [];
    } catch (error) {
      console.error('Error fetching physical fields for arena:', error);
      return [];
    }
  }
}
export const arenaFieldService = new ArenaFieldService();
